import { FrameData } from '../../types';
import { BeatPulse } from '../../utils/audioUtils';
import { hsl } from '../../utils/colorUtils';
import { LayerRenderer } from './LayerRenderer';

export class MirroredBarsRenderer implements LayerRenderer {
  private beatPulse = new BeatPulse(0.92);

  init(): void {}

  render(
    ctx: CanvasRenderingContext2D,
    frame: FrameData,
    settings: Record<string, number>,
    width: number,
    height: number,
  ): void {
    const { frequencyData, isBeat, beatIntensity } = frame;
    const barCount = Math.round(settings.barCount ?? 48);
    const gap = settings.gap ?? 2;
    const colorHue = settings.colorHue ?? 270;
    const glowAmount = settings.glowAmount ?? 12;
    const centerY = height / 2;

    this.beatPulse.update(isBeat, beatIntensity);

    const totalGaps = (barCount - 1) * gap;
    const barWidth = Math.max(1, (width - totalGaps) / barCount);
    const usableBins = Math.floor(frequencyData.length * 0.55);
    const binsPerBar = usableBins / barCount;

    ctx.shadowBlur = glowAmount + this.beatPulse.value * 15;

    for (let i = 0; i < barCount; i++) {
      const startBin = Math.floor(i * binsPerBar);
      const endBin = Math.floor((i + 1) * binsPerBar);
      let sum = 0;
      for (let b = startBin; b < endBin; b++) sum += frequencyData[b];
      const amplitude = sum / (endBin - startBin) / 255;
      const halfBar = amplitude * (height / 2) * 1.1;

      const hue = (i / barCount) * 180 + colorHue;
      const lightness = 50 + this.beatPulse.value * 20;
      const color = hsl(hue, 75, lightness);
      ctx.fillStyle = color;
      ctx.shadowColor = color;

      const x = i * (barWidth + gap);
      ctx.fillRect(x, centerY - halfBar, barWidth, halfBar);
      ctx.fillRect(x, centerY, barWidth, halfBar);
    }

    ctx.shadowBlur = 0;
  }

  resize(): void {}
  destroy(): void {}
}
